import { getWeatherDescription } from "../../utils/helper/weather";
import { getWeatherIcon } from "../../utils/helper/weatherIcon";
import styles from "./styles.module.css";
import { Tag } from "primereact/tag";


function WeatherCard({temperature, temperatureSign, regionCode, city, country, windSpeed, weatherCode}){
    const windTagValue = `wind ${Math.round(windSpeed)} km/h`
    return(
        <div className={styles.weatherCard}>
            <div className={styles.weatherCardTitle}>
                <div>
                    <i className="pi pi-map-marker" />
                </div>
                <div>
                    <span>{city}, {regionCode}, {country}</span>
                </div>
            </div>
            <div className={styles.weatherCardTemperatureBox}>
                <div className={styles.weatherCardTemperatureInfo}>
                    <h4 className={styles.weatherCardTemperatureValue}>{Math.round(temperature)}</h4>
                    <span className={styles.weatherCardTemperatureSign}>{temperatureSign}</span>
                </div>
                <div>
                    {getWeatherIcon(weatherCode, 70)}
                </div>
            </div>
            <div className={styles.weatherCardTags}>
                <div>
                    <Tag 
                    style={{backgroundColor:"#4B556"}} value={windTagValue}/>
                </div>
                <div>
                    <Tag 
                    value={getWeatherDescription(weatherCode)}
                    style={{backgroundColor:"#4B556"}}
                    />
                </div>
            </div>
        </div>
    )
}

export default WeatherCard;